import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import universalLocalStorage from "./utils/lib/universalLocalStorage";

const resources = {
  en: {
    translation: {},
  },
  fr: {
    translation: {},
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

universalLocalStorage.getItem("langPreference").then((languagePreference) => {
  if (!languagePreference) languagePreference = "fr";

  console.log("using the lang", languagePreference);

  if (languagePreference) {
    i18n.changeLanguage(languagePreference);
  } else {
    i18n.changeLanguage();
  }
});

//forces the use of language detector

export default i18n;
